import 'whatwg-fetch'
import {apiTargetMap} from './domain'

export default async (list = {}) => {
  let reqUrl = ""
  let env = process.env.NODE_ENV === 'development'? 'dev':'prod'
  // 四個都是保留字,也就乾脆省略掉呼叫前從Param參數拆解出來的無意義動作
  let apiTarget = list.apiTarget?list.apiTarget:'default'
  let module = list.hasOwnProperty('module')?list.module:''
  let method = list.hasOwnProperty('method')?list.method:''
  let asJson = list.hasOwnProperty('asJson')?list.asJson:false
  reqUrl = apiTargetMap[apiTarget][env] + module + (module?'/':'') + method
  const paramKeys = Object.keys(list)
  const paramfileds = Object.values(list)
  let dataOptions = {
    method: "POST",
    mode: 'cors',
    cache: 'default'
  }
  if (list.useGet) {
    dataOptions.method = "GET"
    for (let i = 0; i < paramKeys.length; i++) {
      if (['apiTarget','module','method','asJson'].includes(paramKeys[i])) {
        continue
      }
      reqUrl += (reqUrl.indexOf('?')!==-1?'&':'?')+ paramKeys[i]+'='+paramfileds[i]
    }
  }
  else {
    let formData = new window.FormData()
    for (let i = 0; i < paramKeys.length; i++) {
      if (['apiTarget','module','method','asJson'].includes(paramKeys[i])) {
        continue
      }
      formData.append(paramKeys[i], paramfileds[i])
    }
    dataOptions.body = formData
  }
  
  // 吃post json的api要補上header與把body轉成json字串
  if (asJson) {
    dataOptions['headers'] = {'Content-Type': 'application/json'}
    dataOptions['body'] = JSON.stringify(dataOptions['body'])
  }
  try {
    const res = await window.fetch(reqUrl, dataOptions)
    const resJson = await res.json()
    return resJson
  } catch (error) {
  // avoid loop error must create something ....
    throw new Error(error)
  }
}